import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { getCurrentChatHistory } from '../history_details/api';
import { showMessage, log } from '../../config/utils';

export function updateFeedbackState(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_FEEDBACK_STATE,
            payload,
            path
        });
    };
}

export function getAllFeedback(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.FEEDBACK_LOADING,
        });
        API.getAllFeedback(data, (error, response) => {
            log('get all feedback response', response);

            if (!error) {
                dispatch({
                    type: actionTypes.FEEDBACK_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.FEEDBACK_ERROR,
                });
            }
        });
    };
}

export function getFeedbackChatlog(data, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "chatlog loading"
        });

        getCurrentChatHistory(data, (error, response) => {
            log('feedback chatlog', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response) {
                dispatch({
                    type: actionTypes.FEEDBACK_CHATLOG_LOADED,
                    payload: response,
                });
                if (callback) callback();
            } else {
                showMessage('error', response && response.message ? response.message : 'can not fetch user chatlog.');
            }
        });
    };
}




// WEBPACK FOOTER //
// ./src/data/redux/feedback_details/actions.js